<div #wrapper class="pdf-wrapper">
  <canvas #bgCanvas class="pdf-bg"></canvas>
  <canvas #fgCanvas class="pdf-fg"></canvas>
</div>
